import React from 'react';
import { useSelector } from 'react-redux';
import AnalyticsManager from '../../../../app/analytics';
import circledArrow from '../../../../assets/icons/slider_circled_arrow_button.svg';
import './index.scss';

const PromotionSlide = ({
    link,
    sliderId,
    sliderTitle,
    sliderAnalyticsType,
    tabId = null,
    tabTitle = null,
}) => {
    const translations = useSelector((store) => store.config.Translations);

    const handleSlideClick = () => AnalyticsManager.logHomepageSliderPromotionSlidePress(
        sliderId, sliderTitle, sliderAnalyticsType, tabId, tabTitle
    );

    return (
        <div className="homepage-promotion-slide">
            <a className="promotion-slide-container" href={link} onClick={handleSlideClick}>
                <img
                    src={circledArrow}
                    alt="Circled Arrow Icon"
                    className="promotion-slide-icon"
                />

                <span className="promotion-slide-text">
                    {translations['slider_category_link_it_does_not_end_here']}
                </span>

                <span className="promotion-slide-text promotion-slide-text_underline">
                    {translations['slider_go_to_more_benefits']}
                </span>
            </a>
        </div>
    );
};

export default PromotionSlide;
